<template>
  <div :class="{ 'is-widget': $rttI18n.$isWidget }" class="alert">
    <BmToast
      v-if="alertStore.type"
      :key="alertStore.revision"
      :closeIconAltText="$t('generic.close')"
      :description="description"
      :on-close="alertStore.clearAlert"
      :timer="timer"
      :title="title"
      :type="alertStore.type"
    />
  </div>
</template>

<script setup>
import { computed, inject, watch } from 'vue';
import { useAlertStore } from '@/stores/alert.js';
import BmToast from '@/v2/design-system/components/Toast/BmToast.vue';
import { requestScrollToWidget } from '@/util/iframeInitHelper.js';

defineProps({
  timer: { type: Number }
});

const alertStore = useAlertStore();
const $rttI18n = inject('rttI18n');
const $t = inject('t');

if ($rttI18n.$isWidget) {
  watch(
    () => alertStore.type,
    type => {
      if (type) {
        requestScrollToWidget();
      }
    }
  );
}

const title = computed(() => {
  const { msg, type } = alertStore;

  // The msg can be a string (legacy), an i18n descriptor ({id, payload}),
  // or a literal-text descriptor ({title, description}).
  if (typeof msg === 'string') return msg;
  if (typeof msg?.title === 'string') return msg.title;
  if (!msg?.id) return '';

  let translationKey;

  if (type === 'error') {
    translationKey = `errorHandling.messages.${msg.id ?? 'generic'}`;
  } else {
    translationKey = msg.id ?? 'generic.successMessage';
  }

  return $rttI18n.tenantSpecificWithFallback(translationKey);
});

const description = computed(() => {
  if (typeof alertStore.msg?.description === 'string') {
    return alertStore.msg.description;
  }
  const payload = alertStore.msg?.payload;

  if (typeof payload === 'string') {
    return $t(payload);
  }

  return payload ?? '';
});
</script>

<style scoped>
.alert {
  position: fixed;
  top: 72px;
  right: 3%;
  left: 3%;
  z-index: 11;
  display: flex;
  flex-direction: column;

  &.is-widget {
    top: 12px;
  }
}

@media (min-width: 480px) {
  .alert {
    right: 0;
    left: auto;
    width: 428px;
    margin: 0 var(--pad-space-sp-20);
  }
}
</style>
